import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import ListItemIcon from '@mui/material/ListItemIcon';
import Typography from '@mui/material/Typography';
import DraftsIcon from '@mui/icons-material/Drafts';
import SendIcon from '@mui/icons-material/Send';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/MenuList": MenuList, "@mui/material/MenuItem": MenuItem, "@mui/material/Paper": Paper, "@mui/material/ListItemIcon": ListItemIcon, "@mui/material/Typography": Typography, "@mui/icons-material/Drafts": DraftsIcon, "@mui/icons-material/Send": SendIcon, "@mui/icons-material/PriorityHigh": PriorityHighIcon } } });
export default ClientProvider;
